import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Staytype.css";

const themes = [
  { theme: "orange", icon: "bi-buildings" },
  { theme: "green", icon: "bi-house-door" },
  { theme: "blue", icon: "bi-door-closed" },
  { theme: "purple", icon: "bi-bank" },
  { theme: "mint", icon: "bi-stars" },
  { theme: "orange", icon: "bi-building" },
];

class Staytype extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchCategories();
  }

  fetchCategories = async () => {
    try {
      this.setState({ loading: true });

      const response = await axios.get("/get_category");
      const fetchedData = response.data.data || response.data || [];

      this.setState({
        categories: fetchedData,
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  handleSearch = (categoryName) => {
    window.location.href = `/q?t=&a=&s=&e=&r=&ad=&k=&c=${encodeURIComponent(
      categoryName
    )}`;
  };

  render() {
    const { categories, loading } = this.state;

    return (
      <section className="staytype-section container-fluid d-flex flex-column justify-content-center align-items-center">
        <h2 className="staytype-title text-center">
          Browse by stay type
        </h2>

        {loading ? (
          <div className="py-5 text-center">Loading categories...</div>
        ) : (
          <div className="staytype-wrapper d-flex flex-nowrap align-items-center w-100 justify-content-start justify-content-xl-center">
            {categories.map((category, index) => {
              const style = themes[index % themes.length];

              return (
                <div
                  key={category.id || index}
                  className="stay-card d-flex align-items-center"
                  onClick={() =>
                    this.handleSearch(category.category_name)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`stay-icon-wrapper theme-${style.theme}`}
                  >
                    <i className={`bi ${style.icon}`}></i>
                  </div>

                  <div className="stay-info d-flex flex-column">
                    <span className="stay-name">
                      {category.category_name}
                    </span>

                    <span className="stay-count">
                      {category.id
                        ? `${category.id} Stays`
                        : "2,450+ Stays"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    );
  }
}

export default Staytype;